// Array Remove - By John Resig (MIT Licensed)
if (typeof Array.prototype.remove != "function") {
    Array.prototype.remove = function(from, to) {
        var rest = this.slice((to || from) + 1 || this.length);
        this.length = from < 0 ? this.length + from : from;
        return this.push.apply(this, rest);
    };
}

// Array Find - From jsPolyfill
if (typeof Array.prototype.find != "function") {
    Array.prototype.find = function(predicate) {
        if (typeof predicate !== 'function') {
            throw new TypeError('Predicate is not a function');
        }

        var list = Object(this);
        // Makes sures is always has an positive integer as length.
        var length = list.length >>> 0;
        var thisArg = arguments[1];

        for (var i = 0; i < length; i++) {
            var element = list[i];
            if (predicate.call(thisArg, element, i, list)) {
                return element;
            }
        }
    };
}

// Add the given item to the top of this Array
if (typeof Array.pushTop != "function") {
    Array.pushTop = function(array, item) {
        return Array.from(item).concat(array);
    };
}

/*
 * Array intersect by Alexander Herrmann (MIT Licensed)
 * From: http://mootools.net/forge/p/array_more
 * Creates an intersection of the current array and the given one.
 */
Array.implement({
    intersect: function(other) {
        var copy = this.slice();
        this.each(function(el) {
            if (other.indexOf(el) < 0) {
                copy.splice(copy.indexOf(el), 1);
            }
        }, this);
        return copy;
    }
});

Object.extend({
    toArray: function(object, fn) {
        var results = [];

        Object.each(object, function(value, key) {
            var item = fn(value, key);
            results.push(item);
        });

        return results;
    }
});

/**
* replaceAll by Fagner Brack (MIT Licensed)
* Replaces all occurrences of a substring in a string
*/
if (typeof String.prototype.replaceAll != "function") {
    String.prototype.replaceAll = function(token, newToken, ignoreCase) {
        var str, i = -1, _token;
        if ((str = this.toString()) && typeof token === "string") {
            _token = ignoreCase === true ? token.toLowerCase() : undefined;
            while ((i = (
                _token !== undefined ?
                    str.toLowerCase().indexOf(
                        _token,
                        i >= 0 ? i + newToken.length : 0
                    ) : str.indexOf(
                        token,
                        i >= 0 ? i + newToken.length : 0
                    )
            )) !== -1) {
                str = str.substring(0, i)
                    .concat(newToken)
                    .concat(str.substring(i + token.length));
            }
        }
        return str;
    };
}

if (typeof String.prototype.equalsIgnoreCase != "function") {
    String.prototype.equalsIgnoreCase = function(str) {
        return this.toLowerCase() == str.toLowerCase();
    };
}

if (typeof String.prototype.containsIgnoreCase != "function") {
    String.prototype.containsIgnoreCase = function(str) {
        str = str.toLowerCase();

        return this.toLowerCase().contains(str);
    };
}

if (typeof String.prototype.startsWith != "function") {
    String.prototype.startsWith = function(str) {
        return this.indexOf(str) == 0;
    };
}

if (typeof String.prototype.startsWithIgnoreCase != "function") {
    String.prototype.startsWithIgnoreCase = function(str) {
        str = str.toLowerCase();

        return this.toLowerCase().startsWith(str);
    };
}

if (typeof String.prototype.endsWith != "function") {
    String.prototype.endsWith = function(str) {
        var index = this.lastIndexOf(str);

        return (index >= 0) && (index == (this.length - str.length));
    };
}

if (typeof String.prototype.endsWithIgnoreCase != "function") {
    String.prototype.endsWithIgnoreCase = function(str) {
        str = str.toLowerCase();

        return this.toLowerCase().endsWith(str);
    };
}

if (typeof String.prototype.matches != "function") {
    String.prototype.matches = function(key, operator) {
        if ((typeof operator == "undefined") || (operator == null))
            operator = "contains";

        if ((typeof key != "undefined") && (key != null)) {
            var self = this.toLowerCase();
            key = key.toLowerCase();
            operator = operator.toLowerCase();

            return (((operator == "startswith") && self.startsWith(key)) ||
                    ((operator == "endswith") && self.endsWith(key)) ||
                    ((operator == "equals") && (self == key)) ||
                    ((operator == "contains") && self.indexOf(key) >= 0));
        }

        return false;
    };
}

if (typeof String.prototype.isLowerCase != "function") {
    String.prototype.isLowerCase = function() {
        return this == this.toLowerCase();
    };
}

if (typeof String.prototype.isUpperCase != "function") {
    String.prototype.isUpperCase = function() {
        return this == this.toUpperCase();
    };
}

if (typeof String.isCharLowerCase != "function") {
    String.isCharLowerCase = function(character) {
        return character == character.toLowerCase();
    };
}

if (typeof String.isCharUpperCase != "function") {
    String.isCharUpperCase = function(character) {
        return character == character.toUpperCase();
    };
}

if (typeof String.prototype.isQuoted != "function") {
    String.prototype.isQuoted = function(quote) {
        if ((typeof quote == "undefined") || (quote == null))
            quote = '"';

        return this.trim().startsWith(quote) && this.trim().endsWith(quote);
    };
}

if (typeof String.prototype.toCapitalCase != "function") {
    String.prototype.toCapitalCase = function(lowerRest) {
        if ((typeof lowerRest == "undefined") || (lowerRest == null))
            lowerRest = true;

        var capital = new StringBuffer();
        capital.append(this.charAt(0).toUpperCase());
        var rest = this.substring(1);
        if (lowerRest)
            rest = rest.toLowerCase();
        capital.append(rest);
        return capital.toString();
    };
}

if (typeof String.prototype.toPrettyFormat != "function") {
    String.prototype.toPrettyFormat = function() {
        var words = [],
            lastUpper;

        var subWords = this.split(' ');
        for (var i = 0; i < subWords.length; i++) {
            lastUpper = 0;
            for (var j = 1; j < subWords[i].length; j++) {
                if (String.isCharUpperCase(subWords[i].charAt(j))) {
                    words.push(subWords[i].substring(lastUpper, j));
                    lastUpper = j;
                }
            }

            if (lastUpper < subWords[i].length)
                words.push(subWords[i].substring(lastUpper, subWords[i].length));
        }

        for (var i = 0; i < words.length; i++)
            words[i] = words[i].toCapitalCase().trim();

        return words.join(' ');
    };
}

/**
* setCharAt by Helder Magalhães
*
* http://www.openjs.com/scripts/strings/setcharat_function.php
*/
if (typeof String.prototype.setCharAt != "function") {
    String.prototype.setCharAt = function(index, chr) {
        if (index > this.length - 1)
            return this;
        return this.substr(0, index) + chr + this.substr(index + 1);
    };
}

/**
* safeSplit by Michael Lebson
* Safely splits a string by the given token without
* destroying the occurances of the token in the string.
*/
if (typeof String.prototype.safeSplit != "function") {
    String.prototype.safeSplit = function(token) {
        var word = this;
        var split = [];
        var tokenIndex = -1;

        // Go through each character
        for (var i = 0; i < word.length; i++) {
            // If this letter is the token
            if (word.charAt(i) == token) {
                // Save the location, if we don't have one already
                if (tokenIndex < 0)
                    tokenIndex = i;
                // Otherwise, do some processing
                else {
                    // If this token isn't at the beginning of the string,
                    // add the part before it to the list of split values
                    if (tokenIndex != 0)
                        split.push(word.substring(0, tokenIndex));

                    // Get the value between the first token
                    // and this one and then save it
                    split.push(word.substring(tokenIndex, i + 1));

                    // Chop off the beginning of this word so we don't process it again
                    word = word.substring(i + 1, word.length);
                    // Start back at the beginning of the word
                    i = 0;
                    // And reset the token index
                    tokenIndex = -1;
                }
            }
        }

        // Add the rest of the word to the split list
        split.push(word);

        // Return the split list
        return split;
    };
}

/**
* Decodes xml-encoded strings
*
* From https://github.com/jnbdz/EncodeAndDecodeXML
*/

if (typeof String.prototype.decodeXML != "function") {
    String.prototype.decodeXML = function() {
        var escaped_to_xml = {
            '&amp;': '&',
            '&quot;': '"',
            '&lt;': '<',
            '&gt;': '>',
            '&#39;': "'"
        };

        return this.replace(/(&quot;|&lt;|&gt;|&amp;|&#39;)/g, function (str, item) {
            return escaped_to_xml[item];
        });
    };
}

if (typeof String.prototype.encodeXML != "function") {
    String.prototype.encodeXML = function() {
        var xml_to_escaped = {
            '&': '&amp;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#39;'
        };
        return String(this).replace(/([\&"<>'])/g, function(str, item) {
            return xml_to_escaped[item];
        });
    };
}

/**
* Implements toISOString function for dates in older browsers (e.g. IE 8)
*/
if (typeof Date.prototype.toISOString != "function") {
    (function() {
        function pad(number) {
            var r = String(number);
            if (r.length === 1)
                r = '0' + r;

            return r;
        }

        Date.prototype.toISOString = function() {
            return this.getUTCFullYear()
                + '-' + pad(this.getUTCMonth() + 1)
                + '-' + pad(this.getUTCDate())
                + 'T' + pad(this.getUTCHours())
                + ':' + pad(this.getUTCMinutes())
                + ':' + pad(this.getUTCSeconds())
                + '.' + String((this.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
                + 'Z';
        };
    }());
}

/*
* JavaScript Pretty Date
* Copyright (c) 2011 John Resig (ejohn.org)
* Licensed under the MIT and GPL licenses.
*/
if (typeof Date.prototype.toPrettyFormat != "function") {
    (function() {
        var SECONDS_IN_MINUTE = 60,
            MINUTES_IN_HOUR = 60,
            HOURS_IN_DAY = 24,
            DAYS_IN_WEEK = 7,
            SECONDS_IN_HOUR = SECONDS_IN_MINUTE * MINUTES_IN_HOUR,
            SECONDS_IN_DAY = SECONDS_IN_HOUR * HOURS_IN_DAY;

        // Takes an ISO time and returns a string showing how long ago the date represents
        Date.prototype.toPrettyFormat = function(relativeDate, showAgo, useShortName) {
            var now = relativeDate || (new Date()),
                secDiff = (now.getTime() - this.getTime()) / 1000,
                dayDiff = Math.floor(secDiff / SECONDS_IN_DAY),
                translateSuffix = (showAgo !== false ? "_ago" : '') + (useShortName !== false ? "_short" : '');

            if (isNaN(dayDiff) || (dayDiff < 0))
                return Librarian.Lang.getString("recently");

            if (dayDiff == 0) {
                if (secDiff < SECONDS_IN_MINUTE)
                    return Librarian.Lang.getArgString("seconds" + translateSuffix, [Math.ceil(secDiff)]);
                if (secDiff < SECONDS_IN_HOUR) {
                    var minutes = Math.floor(secDiff / SECONDS_IN_MINUTE);
                    return Librarian.Lang.getPluralArgString("minutes" + translateSuffix, minutes, [minutes]);
                }

                var hours = Math.floor(secDiff / SECONDS_IN_HOUR);
                return Librarian.Lang.getPluralArgString("hours" + translateSuffix, hours, [hours]);
            }
            else if (dayDiff == 1)
                return Librarian.Lang.getString("yesterday");
            else if (dayDiff < DAYS_IN_WEEK)
                return Librarian.Lang.getPluralArgString("days" + translateSuffix, dayDiff, [dayDiff]);

            var weeks = Math.floor(dayDiff / DAYS_IN_WEEK);
            return Librarian.Lang.getPluralArgString("weeks" + translateSuffix, weeks, [weeks]);
        };
    }());
}

/**
* If the browser can't handle ISO strings, add Date.fromISO to parse it
*
* from http://stackoverflow.com/questions/11020658/javascript-json-date-parse-in-ie7-ie8-returns-nan
*/
(function() {
    var D = new Date('2011-06-02T09:34:29+02:00');
    if (!D || +D !== 1307000069000) {
        Date.fromISO = function(s) {
            var day, tz,
            rx = /^(\d{4}\-\d\d\-\d\d([tT ][\d:\.]*)?)([zZ]|([+\-])(\d\d):(\d\d))?$/,
            p = rx.exec(s) || [];
            if (p[1]) {
                day = p[1].split(/\D/);
                for (var i = 0, L = day.length; i < L; i++) {
                    day[i] = parseInt(day[i], 10) || 0;
                };
                day[1] -= 1;
                day = new Date(Date.UTC.apply(Date, day));
                if (!day.getDate()) return NaN;
                if (p[5]) {
                    tz = (parseInt(p[5], 10) * 60);
                    if (p[6]) tz += parseInt(p[6], 10);
                    if (p[4] == '+') tz *= -1;
                    if (tz) day.setUTCMinutes(day.getUTCMinutes() + tz);
                }
                return day;
            }
            return new Date(s);
        }
    }
    else {
        Date.fromISO = function(s) {
            return new Date(s);
        }
    }
})();

/**
* Implementation of selectSingleNode for browsers that do not already have it.
*
* Adapted from code from
* http://weblogs.asp.net/ssargent/archive/2007/01/25/selectsinglenode-and-firefox.aspx
*/
if (typeof Element.prototype.selectSingleNode != "function") {
    Element.implement({
        selectSingleNode: function(xPath) {
            if (typeof XPathEvaluator == "undefined")
                return null;

            var pathEvaluator = new XPathEvaluator(),
                // FIRST_ORDERED_NODE_TYPE returns the first match to the xpath
                result = pathEvaluator.evaluate(xPath, this, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);

            if (result != null)
                return result.singleNodeValue;
            else
                return null;
        }
    });
}

if ((typeof XMLDocument != "undefined") && (typeof XMLDocument.prototype.selectSingleNode != "function")) {
    XMLDocument.prototype.selectSingleNode = function(xPath) {
        if (typeof XPathEvaluator == "undefined")
            return null;

        var pathEvaluator = new XPathEvaluator(),
        // FIRST_ORDERED_NODE_TYPE returns the first match to the xpath
            result = pathEvaluator.evaluate(xPath, this, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);

        if (result != null)
            return result.singleNodeValue;
        else
            return null;
    };
}

/**
* Implementation of selectNodes for browsers that do not already have it.
*
* Adapted from code from
* http://www.yesjames.com/index.php/2008/11/firefox-compatible-xpath-functions-in-javascript/
*/
if ((typeof XMLDocument != "undefined") && (typeof XMLDocument.prototype.selectNodes != "function")) {
    XMLDocument.prototype.selectNodes = function(cXPathString, xNode) {
        if (!xNode)
            xNode = this;

        var oNSResolver = this.createNSResolver(this.documentElement),
            aItems = this.evaluate(cXPathString, xNode, oNSResolver, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null),
            aResult = [];
        for (var i = 0; i < aItems.snapshotLength; i++)
            aResult[i] = aItems.snapshotItem(i);

        return aResult;
    };
}

if (typeof Element.prototype.selectNodes != "function") {
    Element.implement({
        selectNodes: function(cXPathString) {
            if (this.ownerDocument.selectNodes)
                return this.ownerDocument.selectNodes(cXPathString, this);
        }
    });
}

/**
* Converts a number into a thousands-separated string using the number of decimals,
* the decimal mark, and the thousands separator provided.
*
* Adapted from code by Patrick Desjardins and Marco Demaio
* http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript
*/
if (typeof Number.prototype.toMoney != "function") {
    Number.prototype.toMoney = function(decimals, symbol, decimalMark, seperator) {
        // Default to two decimals if no count or an invalid one are provided
        if ((typeof decimals == "undefined") || (decimals == null) || isNaN(decimals))
            decimals = 2;
        else
            decimals = Math.abs(decimals);

        if ((typeof symbol == "undefined") || (symbol == null))
            symbol = '$';
        if ((typeof decimalMark == "undefined") || (decimalMark == null))
            decimalMark = '.';
        if ((typeof seperator == "undefined") || (seperator == null))
            seperator = ',';

        var number = Math.abs(this).toFixed(decimals);
        var intPart = parseInt(number).toString();
        var seperatorCount = 0;
        if (intPart.length > 3)
            seperatorCount = intPart.length % 3;

        var value = new StringBuffer();

        if (this < 0)
            value.append('-');

        value.append(symbol);
        if (seperatorCount > 0) {
            value.append(intPart.substr(0, seperatorCount));
            value.append(seperator);
        }

        value.append(intPart.substr(seperatorCount).replace(/(\d{3})(?=\d)/g, "$1" + seperator));
        if (decimals > 0) {
            value.append(decimalMark);
            value.append(Math.abs(number - intPart).toFixed(decimals).slice(2));
        }

        return value.toString();
    };
}

/**
* Adds the onhashchange event
*
* authors:
*   sdf1981cgn
*   Greggory Hernandez
*/
Element.Events.hashchange = {
    onAdd: function() {
        var hash = self.location.hash;

        var hashchange = function() {
            if (hash == self.location.hash) return;
            else hash = self.location.hash;

            var value = (hash.indexOf('#/') == 0 ? hash.substr(2) : hash.indexOf('#') == 0 ? hash.substr(1) : hash);
            window.fireEvent("hashchange", value);
            document.fireEvent("hashchange", value);
        };

        if ("onhashchange" in window)
            window.onhashchange = hashchange;
        else
            hashchange.periodical(50);
    }
};

/**
* Element visibility function by WM
*/
Element.implement({
    setVisible: function(visible) {
        if (visible === true || visible == "visible")
            this.setStyle("visibility", "visible");
        else
            this.setStyle("visibility", "hidden");
    }
});

/**
* Adds selected class to current element and removes from siblings
* Arguments:
*   activeClass (optional): Class to add/remove from elements.  Defaults to "active"
*   siblingSelector (optional): CSS selector to match siblings
*
* Added by WM - 9/24/13
*/
Element.implement({
    select: function(activeClass, siblingSelector) {
        if (!activeClass)
            activeClass = "active";

        var siblings = this.getSiblings(siblingSelector);
        siblings.forEach(function(sibling) {
            sibling.removeClass(activeClass);
        });

        this.addClass(activeClass);
    }
});

/**
* Shows this element while hiding siblings
*/
Element.implement({
    showOnly: function (siblingSelector) {
        var siblings = this.getSiblings(siblingSelector);
        siblings.forEach(function (sibling) {
            sibling.hide();
        });

        this.show();
    }
});

/*
 * IE workaround for remove
 */
if (typeof Element.prototype.remove != "function") {
    Element.prototype.remove = function() {
        if (typeof this.removeNode == "function")
            this.removeNode(true);
    }
}


/**
* String buffer implementation by Jon Brito
*/
function StringBuffer() {
    this.buffer = [];
}

StringBuffer.prototype.prepend = function(string) {
    var newBuffer = [];
    newBuffer.push(string);
    this.buffer = newBuffer.append(this.buffer);

    newBuffer = null;

    return this;
};

StringBuffer.prototype.append = function(string) {
    this.buffer.push(string);
    return this;
};

StringBuffer.prototype.toString = function(delimiter) {
    return this.buffer.join(delimiter || '');
};

/**
* Workaround for IE changing the page title when a URL has a hash and a flash object is embedded
*
* http://stackoverflow.com/questions/4562423/ie-title-changes-to-afterhash-if-the-page-has-a-url-with-and-has-flash-s
*/

var originalTitle = document.title.split('#')[0];

function onPropertyChanged(evt) {
    if ((evt.propertyName === "title") && (document.title !== originalTitle)) {
        setTimeout(function() {
            document.title = originalTitle;
        }, 1);
    }
}

function changeTitle(newTitle) {
    originalTitle = newTitle;
    document.title = newTitle;
}

if (document.attachEvent)
    document.attachEvent("onpropertychange", onPropertyChanged);
else if (document.addEventListener)
    document.addEventListener("propertychange", onPropertyChanged, false);

/**
* Convert all keys in a given object to lower case
*/
if (typeof Object.toLowerKeys != "function") {
    Object.toLowerKeys = function(object) {
        var output = {};

        for (var key in object) {
            if (!object.hasOwnProperty(key))
                continue;

            var newKey = key.toLowerCase();

            output[newKey] = object[key];
        }

        return output;
    };
}

if (typeof Object.toCamelKeys != "function") {
    Object.toCamelKeys = function(object) {
        var output = {};

        for (var key in object) {
            if (!object.hasOwnProperty(key))
                continue;

            var newKey = key[0].toLowerCase() + key.substring(1);

            output[newKey] = object[key];
        }

        return output;
    };
}

Class.refactor(Scroller, {
    start: function() {
        this.listener.addEvents({
            mouseover: this.bound.attach
            //mouseleave: this.bound.detach
        });
        return this;
    },

    stop: function() {
        this.listener.removeEvents({
            mouseover: this.bound.attach
            //mouseleave: this.bound.detach
        });
        this.detach();
        this.timer = clearInterval(this.timer);
        return this;
    }
});

(function() {
    var origRefactor = Class.refactor;

    Class.refactor = function(original, refactors) {
        if (!original) {
            if (window.console && window.console.debug)
                window.console.debug("WARN: Attempting to refactor a class that doesn't exist - This is normal on portals");
            return;
        }
        origRefactor(original, refactors);
    }
})();

// Extend drag events
Object.append(Element.NativeEvents, {
    dragenter: 2,
    dragleave: 2,
    dragover: 2,
    drop: 2
});

// Return "blob" in typeOf()
if (typeof Blob != "undefined")
    Blob.prototype.$family = function() { return "blob"; }

// Dummy console for browsers that don't have it (e.g. IE) to avoid errors.
// This should get replaced when the console is opened.
if (!window.console) {
    window.console = {
        log: $empty,
        error: $empty,
        warn: $empty,
        debug: $empty,
        trace: $empty
    };
}